import React from "react";
import Menubar from "../Menubar";


const Bi = () => {
  return (
  <>   <Menubar/>
    <div style={{marginTop:"-0.3%"}}>
    {/* <iframe src="https://app.powerbi.com/reportEmbed?reportId=784dbfa1-1778-4916-861b-f822f0101ec8&autoAuth=true&ctid=d61e24d6-d2ea-4045-9ddc-06cd21e6a149" width="100%" height="100%" style={{ border: "none", height: "100vh" }} title="Power BI Report" allowFullScreen sandbox="allow-same-origin allow-scripts allow-forms allow-popups" referrerPolicy="no-referrer-when-downgrade" /> */}
    <iframe src="https://app.powerbi.com/view?r=eyJrIjoiNjM2YjE5M2QtN2M1OS00NzI5LWE2NTUtMDgyMzlhZTMwOWNlIiwidCI6ImQ2MWUyNGQ2LWQyZWEtNDA0NS05ZGRjLTA2Y2QyMWU2YTE0OSJ9" width="100%" height="100%" style={{ border: "none", height: "100vh" }} title="Power BI Report" allowFullScreen sandbox="allow-same-origin allow-scripts allow-forms allow-popups" referrerPolicy="no-referrer-when-downgrade" />
    
    </div></>
  );
};

export default Bi;